/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// Vision UI Dashboard React Base Styles
import colors from "assets/theme/base/colors";
import borders from "assets/theme/base/borders";

// Vision UI Dashboard  helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { inputColors } = colors;
const { borderWidth, borderRadius } = borders;

export default {
  styleOverrides: {
    root: {
      display: "flex !important",
      border: "none !important",
      borderRadius: `${borderRadius.md} !important`,
      backgroundColor: "#ffffff",

      "& fieldset": {
        border: `${borderWidth[1]} solid rgba(0, 87, 216, 0.2)`,
        borderRadius: borderRadius.md,
        transition: "border-color 150ms ease",
      },
      "&:hover fieldset": {
        borderColor: "rgba(0, 87, 216, 0.4) !important",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#0057d8 !important",
        borderWidth: "1px !important",
      },
    },
  },
};

